import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Contacto from "./components/Contact/Contact";
import Home from "./components/Home/Home";
import CnGroup from "./components/CN/CN";
import Servicios from "./components/Servicios/Servicios";
import Clientes from "./components/Client/Clientes";
import HouseClient from "./components/Client/Gallery/house_client";
import ConstClient from "./components/Client/Gallery/const_client";
import PanelClient from "./components/Client/Gallery/panel_client";
import TrajectorySection from "./components/Home/TrajectorySection/TrajectorySection";
import ProjectGallery from "./components/Client/Gallery/project_gallery";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cngroup" element={<CnGroup />} />
          <Route path="/servicios" element={<Servicios />} />
          <Route path="/clientes" element={<Clientes />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/paneles-solares-detalle" element={<PanelClient />} />
          <Route path="/promocion-inmobiliaria-detalle" element={<HouseClient />} />
          <Route path="/obra-civil-detalle" element={<ConstClient />} />
          <Route path="/trajectorysection" element={<TrajectorySection />} />
          <Route path="/cngroup/:slideIndex?" element={<CnGroup />} />
          <Route path="/servicios/:id" element={<Servicios />} />
          <Route path="/galeria-viviendas/:projectId" element={<ProjectGallery />} />
          <Route path="/galeria-paneles/:projectId" element={<ProjectGallery />} />
          <Route path="/galeria-construccion/:projectId" element={<ProjectGallery />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;